import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentService } from './document.service';
import { catchError } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../shared/core/http.service';
import { ViewingSessionModel } from './viewingsession.model';
import { data } from 'jquery';
import { Location } from '@angular/common';
import { NotificationsService, Notification } from '../shared/helper-components';
import { ComponentCanDeactivate } from '../shared/core';
import { ClearanceItemService } from '../clearance-item/clearance-item.service';
const EMPTY_OBSERVABLE: Observable<never> = empty();

@Component({
  selector: 'app-document-detail',
  template: require('./document-detail.component.html'),
  styles: [require('./document-detail.component.css')]
})
export class DocumentDetailComponent implements OnInit, ComponentCanDeactivate {
  filename: string;
  viewingSessionId: string = '';
  viewerControl: any;
  canInteract = false;
  error: Error = null;
  originalname:string;
  spinnerIsRunning:boolean = false;
  annotationsSaved: boolean = true;
  projectId: string;
  ciId: string;
  assetType: string;
  imageIndex: number;
  openedFrom: string = '';
  ciListQueryString: string = '';
  @ViewChild('saveScrimsAnnotation') saveScrimsAnnotation: ElementRef;
  @ViewChild('saveButtonWrapper') saveButtonWrapper: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private documentService: DocumentService,
    private _httpService: HttpService,
    private location: Location,
    private _notificationsService: NotificationsService,
    private _clearanceItemService: ClearanceItemService,
    private _router: Router,
  ) {
    this.filename = this.route.snapshot.paramMap.get('filename')!;
    this.originalname = this.route.snapshot.paramMap.get('originalname')!;
    this.projectId = this.route.snapshot.paramMap.get('projectId')!;
    this.ciId = this.route.snapshot.paramMap.get('ciId')!;
    this.assetType = this.route.snapshot.paramMap.get('assetType')!;
    this.imageIndex = parseInt(this.route.snapshot.paramMap.get('imageIndex'));
    this.openedFrom = this.route.snapshot.paramMap.get('from');
    this.ciListQueryString = decodeURIComponent(this.route.snapshot.paramMap.get('query'));
  }

  ngOnInit(): void {
    var parent = this;
    this.documentService.createViewingSession(this.filename)
      .subscribe(
        (data: ViewingSessionModel) => {
          parent.viewingSessionId = data.viewingSessionId;
          this.viewingSessionId = data.viewingSessionId;
        },
        (error) => {
          console.error('Error:', error);
        }
      )
  }


mapViewingSession(response: Response): ViewingSessionModel {
  var data: any = response.json();
  if (data){
    let viewingSessionModel: ViewingSessionModel = new ViewingSessionModel();
    viewingSessionModel.viewingSessionId = data.viewingSessionId;
    this.viewingSessionId = viewingSessionModel.viewingSessionId;
    return viewingSessionModel;
  }
  return null;
}

  // Call this method to store a reference to the viewerControl so we can use its API.
  setViewerControl(viewerControl: any): void {
    // Store a reference to the viewerControl.
    this.viewerControl = viewerControl;
    var parent = this;

    // Update our "canInteract" variable whenever the viewer is fully ready. For
    // the full list of PCCViewer.EventType values you can subscribe to, see
    // https://help.accusoft.com/PrizmDoc/v13.13/HTML/PCCViewer.html#.EventType
    this.viewerControl.on((window as any).PCCViewer.EventType.ViewerReady, () => {
      this.canInteract = true;
      parent.viewerControl.scaleFactor = 1;
      parent.viewerControl.fitContent("FullPage");
    });
  }

  // Calls the viewerControl API to navigate to the next page.
  nextPage(): void {
    this.viewerControl.changeToNextPage();
  }

  // Calls the viewerControl API to navigate to the previous page.
  previousPage(): void {
    this.viewerControl.changeToPrevPage();
  }

  return(){
    if (this.openedFrom == 'ciDetail'){
      this._router.navigateByUrl('/projects/' + this.projectId + '/items/' + this.ciId + "/" + this.assetType + "/" + this.imageIndex);
    }
    else{
      this._router.navigateByUrl('/projects/' + this.projectId + '/items' + this.ciListQueryString + "&ciId=" + this.ciId + "&imageIndex=" + this.imageIndex);
    }
  }

  toggleSpinner(){
    this.spinnerIsRunning = !this.spinnerIsRunning;
  }

  showSuccessMessage(){
    this._notificationsService.add(new Notification('success', 'Annotation saved successfully.'));
    this._clearanceItemService.postSendFtrackNotificacion(this.ciId);
  }

  showErrorMessage(){
    this._notificationsService.add(new Notification('error', 'The image could not be saved, please try again.'));
  }

  onAnnotationsChanged($event){
    const saveScrimsAnnotation = this.saveScrimsAnnotation.nativeElement;
    const saveButtonWrapper = this.saveButtonWrapper.nativeElement;
    saveScrimsAnnotation.style["background-color"] = "#f9a825";
    saveScrimsAnnotation.style["pointer-events"] = "auto";
    saveButtonWrapper.style["cursor"] = "pointer";
    this.annotationsSaved = false;
  }

  disableSaveButton(){
    const saveScrimsAnnotation = this.saveScrimsAnnotation.nativeElement;
    const saveButtonWrapper = this.saveButtonWrapper.nativeElement;
    saveScrimsAnnotation.style["background-color"] = "dimgray";
    saveScrimsAnnotation.style["pointer-events"] = "none";
    saveButtonWrapper.style["cursor"] = "not-allowed";
    this.annotationsSaved = true;
 }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
      return this.annotationsSaved;
  }
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/docviewer/document-detail.component.ts